module.exports = __webpack_public_path__ + "img/sp-thumbnail.5f9d8e3c.png";